<template>
  <div class="page-container" v-wechat-title="titleTop">
    
    <!-- 1. 顶部导航 (Sticky) -->
    <header class="sticky-header">
      <div class="header-inner">
        <a class="back-btn" @click="onBack">
          <svg viewBox="0 0 320 512" width="10" height="16" fill="currentColor">
            <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"/>
          </svg>
        </a>
        <h1 class="header-title">{{ title }}</h1>
      </div>
    </header>

    <!-- 2. 列表内容区域 -->
    <main class="main-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div 
          v-for="(item, index) in list" 
          :key="index" 
          class="exam-card"
        >
          
          <!-- CASE 1: 进行中 (未完成) -->
          <template v-if="!item.finishTime">
            <div class="card-strip bg-gray"></div>
            
            <div class="card-header">
              <div class="header-left">
                <h3 class="exam-name">{{ item.examName }}</h3>
              </div>
              <div class="header-right">
                <span class="status-badge badge-gray">进行中</span>
                <span class="exam-date">{{ formatDate(item.beginTime, 'yyyy/MM/dd', true) }}</span>
              </div>
            </div>

            <div class="card-footer">
              <div class="score-area">
                <span class="score-label">剩余时间</span>
                <van-count-down
                  class="countdown-display"
                  :time="item.examFinishTime"
                  :format="item.examFinishTime > 3600000 ? 'HH:mm:ss' : 'mm:ss'"
                  @finish="onCountFinish"
                />
              </div>
              <div class="btn-group">
                <button class="action-btn btn-primary" @click="onExam(item)">
                  继续测验
                  <svg viewBox="0 0 448 512" width="10" height="10" fill="currentColor" style="margin-left:4px"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
                </button>
              </div>
            </div>
          </template>

          <!-- CASE 2: 已通过 -->
          <template v-if="item.finishTime && item.isPass">
            <div class="card-strip bg-blue"></div>

            <div class="card-header">
              <div class="header-left">
                <h3 class="exam-name">{{ item.examName }}</h3>
              </div>
              <div class="header-right">
                <span class="status-badge badge-blue">通过测试</span>
                <span class="exam-date">{{ formatDate(item.beginTime, 'yyyy/MM/dd', true) }}</span>
              </div>
            </div>

            <div class="card-footer">
              <div class="score-area">
                <span class="score-label">最终得分</span>
                <span class="score-num text-gradient-pass">
                  {{ parseInt(item.myScore * 100 / item.totalScore) }}<span class="score-unit">分</span>
                </span>
              </div>
              <div class="btn-group">
                <button class="action-btn btn-outline" @click="onErrorList(item.examResultId)">
                  <svg viewBox="0 0 384 512" width="10" height="10" fill="currentColor" style="margin-right:4px"><path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>
                  错题回顾
                </button>
                <button class="action-btn btn-primary" @click="onExamPrint(item.examResultId)">
                  <svg viewBox="0 0 576 512" width="10" height="10" fill="currentColor" style="margin-right:4px"><path d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V299.6l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"/></svg>
                  导出答题卡
                </button>
              </div>
            </div>
          </template>

          <!-- CASE 3: 未通过 -->
          <template v-if="item.finishTime && !item.isPass">
            <div class="card-strip bg-red"></div>

            <div class="card-header">
              <div class="header-left">
                <h3 class="exam-name">{{ item.examName }}</h3>
              </div>
              <div class="header-right">
                <span class="status-badge badge-red">未通过</span>
                <span class="exam-date">{{ formatDate(item.beginTime, 'yyyy/MM/dd', true) }}</span>
              </div>
            </div>

            <div class="card-footer">
              <div class="score-area">
                <span class="score-label">最终得分</span>
                <span class="score-num text-gradient-fail">
                  {{ parseInt(item.myScore * 100 / item.totalScore) }}<span class="score-unit">分</span>
                </span>
              </div>
              <div class="btn-group">
                <button class="action-btn btn-outline" @click="onErrorList(item.examResultId)">
                  <svg viewBox="0 0 384 512" width="10" height="10" fill="currentColor" style="margin-right:4px"><path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>
                  错题回顾
                </button>
                <button class="action-btn btn-primary" @click="onExamPrint(item.examResultId)">
                  <svg viewBox="0 0 576 512" width="10" height="10" fill="currentColor" style="margin-right:4px"><path d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V299.6l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"/></svg>
                  导出答题卡
                </button>
              </div>
            </div>
          </template>

        </div>
      </van-list>
    </main>
  </div>
</template>

<script>
import request from '@/utils/request'
import { Button, List, CountDown } from 'vant'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'

export default {
  name: 'MyExamList',
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [CountDown.name]: CountDown
  },
  data() {
    return {
      titleTop: '',
      title: '我的测验',
      backurl: '/my/index',
      loading: false,
      finished: false,
      list: [],
      search: {
        limit: 30,
        page: 1
      }
    }
  },
  created() {
    this.titleTop = GetSysTitle()
  },
  methods: {
    ShowMoney,
    GetDiveMainBack,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,

    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.loading = true
      this.onLoad()
    },

    onLoad() {
      request({
        url: '/DiveLearn/getUserExamResultList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.loading = false
          this.finished = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },

    onCountFinish() {
      this.init() // 倒计时结束刷新列表
    },

    onExam(item) {
      if (item.finishTime !== null) return
      if (item.hashCode === null) return
      this.$router.push('/divetrip/exam?hashCode=' + item.hashCode)
    },

    onErrorList(id) {
      this.$router.push('/divetrip/examErrorList/' + id)
    },

    onExamPrint(id) {
      this.$router.push('/divetrip/examPrint/' + id)
    },

    onBack() {
      this.$router.push(this.backurl)
    }
  }
}
</script>

<style scoped>
/* 引入字体 */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@500;700&display=swap');

/* 全局重置 */
* { box-sizing: border-box; }

.page-container {
  min-height: 100vh;
  background-color: #F9FAFB;
  font-family: 'Inter', sans-serif;
  color: #0A2540;
  display: flex;
  flex-direction: column;
}

/* --- Sticky Header --- */
.sticky-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #E5E7EB;
  position: sticky;
  top: 0;
  z-index: 40;
  height: 3.5rem;
}

.header-inner {
  max-width: 28rem;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 1rem;
}

.back-btn {
  position: absolute;
  left: 1rem;
  color: #9CA3AF;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.header-title { font-size: 1rem; font-weight: 700; color: #0A2540; margin: 0; }

/* --- Content --- */
.main-content {
  flex: 1;
  max-width: 28rem;
  margin: 0 auto;
  width: 100%;
  padding: 1rem;
}

/* --- Card Styles --- */
.exam-card {
  background: white;
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
  border: 1px solid #F3F4F6;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
  transition: all 0.2s;
}
.exam-card:active { transform: scale(0.99); }

/* Left Color Strip */
.card-strip {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
}
.bg-blue { background-color: #0057FF; }
.bg-red { background-color: #EF4444; }
.bg-gray { background-color: #D1D5DB; }

/* Header Info */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  padding-left: 0.75rem; /* Space for strip */
}

.exam-name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0A2540;
  margin: 0 0 0.25rem 0;
  line-height: 1.4;
}

.header-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.status-badge {
  font-size: 0.625rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}
.badge-blue { background-color: #EFF6FF; color: #0057FF; }
.badge-red { background-color: #FEF2F2; color: #EF4444; }
.badge-gray { background-color: #F3F4F6; color: #6B7280; }

.exam-date {
  font-size: 0.625rem;
  color: #9CA3AF;
  font-family: 'JetBrains Mono', monospace;
}

/* Footer & Score */
.card-footer {
  display: flex;
  justify-content: space-between;
  /* 关键修改：底部对齐，让分数和按钮底边共线 */
  align-items: flex-end;
  padding-left: 0.75rem;
  border-top: 1px dashed #F3F4F6;
  padding-top: 1rem;
  margin-top: 0.5rem;
}

/* 防止左侧被挤压 */
.score-area { 
  display: flex; 
  flex-direction: column; 
  flex-shrink: 0; 
}

.score-label {
  font-size: 0.625rem;
  color: #9CA3AF;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px; /* 微调：标签和数字的间距 */
}

.score-num {
  font-size: 2.25rem;
  font-weight: 700;
  font-family: 'JetBrains Mono', monospace;
  line-height: 1; /* 紧凑行高，确保底部对齐准确 */
}
.score-unit { font-size: 0.875rem; color: #9CA3AF; margin-left: 2px; font-weight: 400; }

.countdown-text {
  font-size: 1rem;
  font-weight: 700;
  color: #4B5563;
  font-family: 'JetBrains Mono', monospace;
  margin-top: 0.25rem;
}

.countdown-display {
  font-size: 1.5rem; 
  font-weight: 700;
  color: #4B5563;
  font-family: 'JetBrains Mono', monospace;
  line-height: 1;
}

/* Gradients */
.text-gradient-pass {
  background: linear-gradient(135deg, #0057FF 0%, #06B6D4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text-gradient-fail {
  background: linear-gradient(135deg, #EF4444 0%, #F97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Buttons */
.btn-group { display: flex; gap: 0.375rem; }

.action-btn {
  padding: 0.5rem 0.5rem; /* 左右间距再微调 */
  border-radius: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; /* 内容居中 */
  gap: 0.375rem;
  transition: all 0.2s;
  height: 2rem;
  min-width: 6rem; /* 关键修改：固定最小宽度，整齐划一 */
  white-space: nowrap;
}

.btn-primary {
  background-color: #0057FF;
  color: white;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 87, 255, 0.2);
}
.btn-primary:active { transform: scale(0.98); }

.btn-outline {
  background-color: white;
  color: #4B5563;
  border: 1px solid #E5E7EB;
}
.btn-outline:active { background-color: #F9FAFB; }

</style>